module.exports = __webpack_public_path__ + "static/img/11.a9d9ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/11.jpg
// module id = 8qLq
// module chunks = 4